const scandia_org = "aaa9a975-fbcb-41b4-a2dd-3f404f6920a1";
const rowly_demo_org = "r0wlyg0x-b3st-g0go-d3m0-c0d3mon73yz0";
const ramirent_org = "eb267261-415e-48b2-94cf-7915f7430e65";
const tahko_org = "928e1501-73e8-4125-9ff8-3a5ff68c92f8";
const puuilo_prod_org = "be5e32fc-3893-4c46-a22e-5c5c38ef1e00";
const tokmanni_prod_org = "9d099f0f-486c-4c12-a6e2-f8ac7f006387";

export const paymentEnabled = (env, company) => {
  try {
    if (company?.features?.enableVismaPay) {
      return true;
    }
    // Old way of checking from Env variable. TODO: Completely replace with check from above
    if (company?.group) {
      const featureGroups = process.env.REACT_APP_FEATURE_PAYMENT.split(" ");
      const enabled = featureGroups.includes(company.group);
      return enabled;
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const strongAuthEnabled = (env, group) => {
  if (env === "local" || env === "dev" || env === "staging" || env === "dev2")
    return true;
  try {
    const featureGroups = process.env.REACT_APP_FEATURE_SIGN.split(" ");
    const enabled = featureGroups.includes(group);
    return enabled;
  } catch (e) {
    return false;
  }
};

export const enableProductTypeCategories = (organizationId) => {
  const featureOrganizations = [
    "aaa9a975-fbcb-41b4-a2dd-3f404f6920a1", // Scandia Rent
    "06af3a3c-3f46-4fbd-aac1-613e10c8251e", // BR-Autovuokraamo Bestrent
  ];
  if (featureOrganizations.includes(organizationId)) return true;
  return false;
};

export const askSsn = (group) => {
  const featureGroups = [
    "stadinpakut",
    "pakunvuokraus",
    "prgroup",
    "vuokraapaku",
    "THERent",
    "nlp-group",
  ];
  const enabled = featureGroups.includes(group);
  return enabled;
};

export const askDriverSsn = (group) => {
  const featureGroups = ["vuokraapaku", "janne"];
  const enabled = featureGroups.includes(group);
  return enabled;
};

export const disableCreditcheck = (group) => {
  const featureGroups = [
    "khautovuokraus",
    "polareyllas",
    "joensuunkauhojat",
    "ebikerental",
    "jyrkila",
    "gnista",
    "rsteam",
    "huuma",
    "kauppi_leasing",
    "s-company",
    "jyvaskylakaupunki",
    "majakkawatersportslohja",
    "ms_vuokraus",
    "9d099f0f-486c-4c12-a6e2-f8ac7f006387", // Tokmanni
  ];
  const enabled = featureGroups.includes(group);
  return enabled;
};

export const showPortInstruction = (companyId) => {
  // ID of group rsteam company vesijetit
  return companyId === "f2b7b12a-b755-4751-8802-934e63fcd8db" ? true : false;
};

export const enableVismaSign = (env, group) => {
  if (env === "local" || env === "staging" || env === "dev2") {
    return true;
  }
  try {
    const featureGroups = process.env.REACT_APP_FEATURE_SIGN.split(" ");
    const enabled = featureGroups.includes(group);
    return enabled;
  } catch (e) {
    console.error(e);
    return false;
  }
};

// Higher limit of Visma Pay in cents
export const vismaPayMaxPayment = (group) => {
  // Visma pay maximum payment is higher for certain customers
  if (
    group === "prgroup" ||
    group === "freedomvuokraus" ||
    group === "caravankeidas" ||
    group === "caravanlandia" ||
    group === "zenrentals" ||
    group === "roberts"
  ) {
    return 600000;
  }
  return 200000;
};

export const hideZeroPrices = (env, company) => {
  const featureCompanies = [
    "6aec4644-93bb-4bb3-bdc0-26f28a4d8cdf",
    "0781af03-dbcc-4b7f-aa37-ada4a1b09658", // jkl
    "7ba188b4-c6a7-4200-9579-97999e93699e", //jkl
  ];
  if (featureCompanies.includes(company?.id)) return true;
  return false;
};

export const replaceWorkIcon = (env, company) => {
  if (company.id === "6aec4644-93bb-4bb3-bdc0-26f28a4d8cdf") return true;
  return false;
};

export const replaceVolumeIcon = (env, company) => {
  if (company.group === "ebikerental") return true;
  return false;
};
// Don't show and require all the input fields
export const enableMinimalCustomerInput = (env, group) => {
  if (group === "joensuunkauhojat") return true;
  return false;
};

export const isDev = (env, group) => {
  if (env === "local") return true;
  return false;
};

export const enablePrivacyPolicy = (env, group) => {
  if (group === "joensuunkauhojat") return true;
  return false;
};

// Be careful with this setting, as it will not behave correctly if all Companys
// within the group use the same settings.
// If enabled, return a Company with wanted settings. (businessHours, feature flags..)
export const selectAllCompanies = (companies) => {
  const groups = window.URENT_APP_GROUPS;
  //const groups = ["ville"];
  if (!groups || groups.length > 1) return false;
  const group = groups[0];
  // debug
  //if (group === "ville") {
  //const companySettings = companies.find(
  //(c) => c.id === "e861d76e-cd62-4415-8b80-1eacd63249de"
  //);
  //return {
  //...companySettings,
  //id: "all",
  //};
  //}
  // Vuokraapaku
  if (group === "vuokraapaku") {
    // Get a first 24/7 company (for vuokraapaku only Sörnäinen with no 24/7 has disableOffHourReturn)
    const companySettings = companies.find((c) => !c.disableOffHourReturn);
    return {
      ...companySettings,
      id: "all",
    };
  }
  return false;
};

// DO NOT USE FOR NOW.
export const selectAllCompanyIds = (companies) => {
  const groups = window.URENT_APP_GROUPS;
  //const groups = ["ville"];
  if (!groups || groups.length > 1) return false;
  const group = groups[0];
  // debug
  //if (group === "ville") {
  //const filteredCompanies = companies.filter(
  //(c) =>
  //c.id === "e861d76e-cd62-4415-8b80-1eacd63249de" ||
  //c.id === "967c17a0-2cd2-44cb-9937-d52199261e41"
  //);
  //const companyIds = filteredCompanies.map((c) => c.id);
  //return companyIds;
  //}
  if (group === "vuokraapaku") {
    // Should now work with all Companys
    //const filteredCompanies = companies.filter((c) => !c.disableOffHourReturn);
    const companyIds = companies.map((c) => c.id);
    return companyIds;
  }
  return false;
};

// If customized label for payment on pickup is set, return the label. Otherwise false.
export const paymentOnPickupLabel = (group) => {
  if (
    group === "ebikerental" ||
    group === "majakkawatersports" ||
    group === "majakkawatersportslohja"
  ) {
    return "Maksa liikuntaedulla noudon yhteydessä. (ePassi, Smartum, Edenred, Eazybreak)";
  }
  if (
    group === "elämysristeilyt" ||
    group === "tampereensaunalautta" ||
    group === "freedomvuokraus"
  ) {
    return "Maksu myöhemmin laskulla";
  }

  return false;
};
//
// If customized label for differentDriver is set, return the label. Otherwise false.
export const differentDriverLabel = (group) => {
  if (group === "jyrkila") {
    return "Lisäkuljettaja";
  }
  return false;
};

export const uRentLogoVisibility = (group) => {
  if (!group) return true;
  if (group === "majakkawatersports" || group === "majakkawatersportslohja") {
    return false;
  }
  return true;
};

export const hideFilters = (group) => {
  if (group === "gnista") {
    return true;
  }
  return false;
};

export const hideCategories = (group) => {
  if (group === "gnista") {
    return true;
  }
  return false;
};

export const hideAdditionalServicesTitle = (group) => {
  if (group === "gnista") {
    return true;
  }
  return false;
};

// TODO
export const dateRangeTitle = (group) => {
  if (group === "gnista") {
    return "Timeframe custom title";
  }
  return "Timeframe default title";
};

export const disableAdditionalDriver = (group) => {
  const featureGroups = ["gnista", "huuma"];
  const enabled = featureGroups.includes(group);
  return enabled;
};

export const disableCustomerIsCompany = (group) => {
  if (group === "gnista") {
    return true;
  }
  return false;
};

export const setDisablePaymentMethodBilling = (group) => {
  const featureGroups = ["gnista", "janne", puuilo_prod_org];
  const enabled = featureGroups.includes(group);
  return enabled;
};

export const setFixedReservationDuration = (id, companies) => {
  if (!companies) return;

  const featureCompanyIds = [
    "bd1ac06b-fc86-470f-8a85-9d3a07d7f3b1",
    "e5dab512-e238-41b9-9be8-35b0c31b0ddc",
  ];

  const enabled = featureCompanyIds.includes(id);

  if (enabled) {
    console.log("FEATURE_FIXED_RESERVATION_DURATION ACTIVE");
  }
  return enabled;
};

export const setFixedReservationTimeFrame = (id) => {
  const featureCompanyIds = [
    "a5b329e2-fb7e-11ec-b939-0242ac120002",
    "e6be247e-4cea-49f9-84ac-8d44e09722eb",
  ];
  const enabled = featureCompanyIds.includes(id);
  if (enabled) {
    console.log("FEATURE_PREDETERMINED_RESERVATION_RETURNTIME ACTIVE");
  }
  return enabled;
};

export const disableSentry = () => {
  const groups = window.URENT_APP_GROUPS;
  return groups && groups[0] === "zenrentals"; // Customers site has problem with event listeners if Sentry is on
};

export const enableOptionalFixedReservationDuration = (companyId) => {
  if (!companyId) return false;
  //  if (company?.organizationId) return false // If life gets too exciting, enable this
  const dev_companies = ["9d4d978c-1150-11ed-861d-0242ac120002"];

  const featureCompanies = [
    "0aaad654-9515-4cbb-bf8d-040a68f9b8c5", // ms_vuokraus
  ];

  // Check if any companyId matches dev_org or scandia_org
  const isEnabled = featureCompanies.includes(companyId);
  return isEnabled;
};

export const orderCompaniesAlphabetically = (company) => {
  if (
    company?.organizationId === puuilo_prod_org ||
    company?.organizationId === tokmanni_prod_org
  ) {
    return true;
  }
  return false;
};

export const hideVouchers = (group) => {
  const featureGroups = ["kauppi_leasing", "jyvaskylakaupunki"];
  const enabled = featureGroups.includes(group);

  return enabled;
};
